import { http_billing } from './http'
import { i18n } from '@/translations/i18n'
import { punctToSlash } from '@/helper'

export default {
  getSubscriptionItems(target, params) {
    return http_billing.get(punctToSlash(target), {
      params: {
        locale: i18n.formatedLocale,
        ...params,
      },
    })
  },
  getSubscriptionItem(target, params) {
    return this.getSubscriptionItems(target, params)
  },
  editSubscriptionItem(target, params) {
    return http_billing.put(punctToSlash(target), {
      locale: i18n.formatedLocale,
      ...params,
    })
  },
  deleteSubscriptionItem(target, data, params) {
    return http_billing.delete(punctToSlash(target), {
      data,
      params: {
        ...params,
      },
    })
  },
}
